// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U543HU {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
  width: 100%;
  max-width: 544px;
  margin: 0 auto;
}

.AeToQ_ {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.Tk_CzG {
  width: 100%;
}

.TwJadG {
  background: var(--success-green-light, #eaffe5);
  border: 1px solid var(--success-green, #387c2b);
  border-radius: var(--radius-s, 4px);
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  width: 100%;
}

.jgUZ7K {
  background: var(--inline-error-background, #fee7e7);
  border: 1px solid var(--status-error, #dc0a0a);
  border-radius: var(--radius-s, 4px);
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  width: 100%;
}

.cW0VnA {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  padding: var(--spacing-0-5, 4px) 0px;
}

.COBjJS {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: var(--success-green, #387c2b);
}

.MZljds {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: var(--status-error, #dc0a0a);
}

.X0lS7h {
  margin: 0;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  color: var(--text-neutral-dark, #1f1f1f);
  line-height: var(--line-height-180, 1.8);
  flex: 1;
}

.pz_Edo {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2, 16px);
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/ResetPassword/components/FinishedResetPassword/FinishedResetPassword.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,+CAA+C;EAC/C,mCAAmC;EACnC,uDAAuD;EACvD,WAAW;AACb;;AAEA;EACE,mDAAmD;EACnD,8CAA8C;EAC9C,mCAAmC;EACnC,uDAAuD;EACvD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,iEAAiE;EACjE,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,wCAAwC;EACxC,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;AACb","sourcesContent":[".finishedResetPasswordWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n  width: 100%;\n  max-width: 544px;\n  margin: 0 auto;\n}\n\n.finishedResetPasswordTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.finishedResetPasswordToastContainer {\n  width: 100%;\n}\n\n.finishedResetPasswordToast {\n  background: var(--success-green-light, #eaffe5);\n  border: 1px solid var(--success-green, #387c2b);\n  border-radius: var(--radius-s, 4px);\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  width: 100%;\n}\n\n.finishedResetPasswordToastError {\n  background: var(--inline-error-background, #fee7e7);\n  border: 1px solid var(--status-error, #dc0a0a);\n  border-radius: var(--radius-s, 4px);\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  width: 100%;\n}\n\n.finishedResetPasswordToastContent {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  padding: var(--spacing-0-5, 4px) 0px;\n}\n\n.finishedResetPasswordToastIcon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  color: var(--success-green, #387c2b);\n}\n\n.finishedResetPasswordToastIconError {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  color: var(--status-error, #dc0a0a);\n}\n\n.finishedResetPasswordToastMessage {\n  margin: 0;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  color: var(--text-neutral-dark, #1f1f1f);\n  line-height: var(--line-height-180, 1.8);\n  flex: 1;\n}\n\n.finishedResetPasswordActions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2, 16px);\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"finishedResetPasswordWrapper": `U543HU`,
	"finishedResetPasswordTitle": `AeToQ_`,
	"finishedResetPasswordToastContainer": `Tk_CzG`,
	"finishedResetPasswordToast": `TwJadG`,
	"finishedResetPasswordToastError": `jgUZ7K`,
	"finishedResetPasswordToastContent": `cW0VnA`,
	"finishedResetPasswordToastIcon": `COBjJS`,
	"finishedResetPasswordToastIconError": `MZljds`,
	"finishedResetPasswordToastMessage": `X0lS7h`,
	"finishedResetPasswordActions": `pz_Edo`
};
module.exports = ___CSS_LOADER_EXPORT___;
